import { useDispatch } from "react-redux"
import { setIsOpenDialog } from "../../store/feautures/DialogSlice";
import { useDeleteCategoryMutation } from "../../store/services/CategoryService";
import { toast } from "react-toastify";

type IProps = {
    idAzienda: number,
    dataInfo: any
}

export default function DeleteCategory({ idAzienda, dataInfo }: IProps) {

    const dispatch = useDispatch();
    const [deleteCategory] = useDeleteCategoryMutation();

    const handleClose = () => {
        dispatch(setIsOpenDialog(true));
    }

    const handleDelete  = async () => {
        const result: any = await deleteCategory({ idAzienda: idAzienda, idCategoria: dataInfo.id });
        if ('error' in result) {
            toast.error(`Categoria non eliminata! Errore: ${result?.error?.data?.detail}`)
        } else {
            toast.success(`Categoria eliminata! `);
            dispatch(setIsOpenDialog(true));
        }
    }

    return (
        <div className="p-10 min-h-[300px] flex flex-col justify-between">
            <p>Sei sicuro di voler eliminale la categoria {dataInfo.nome} ?</p>
            <div className="mt-4 grid grid-cols-2 space-x-4">
                <button onClick={handleClose} type="button" className="h-10 border !text-[#064e3b] !border-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Annulla
                </button>
                <button onClick={handleDelete} type="button" className="h-10 bg-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Elimina
                </button>
            </div>
        </div>
    )
}